<template>
  <v-card color="transparent" flat tile>
    <v-card-text class="text-center">
      <div class="mb-4">
        <ReviewStars
          v-if="value.stars === '4' || value.stars === '5'"
          :value="value.stars"
          color="cyan-accent-2"
        />
        <v-icon
          v-else
          :icon="mdiCommentQuote"
          :size="30"
          color="cyan-accent-2"
        />
      </div>

      <p v-if="value.short_text" class="text-body-0">
        &ldquo;{{ value.short_text }}&rdquo;
      </p>

      <div class="text-caption text-uppercase mt-4">
        <ReviewSource :value="value.source" />
        <ReviewName prepend-text="–" :value="value" />
      </div>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import type { components } from '#root/types/directus'
import { mdiCommentQuote } from '@mdi/js'

defineProps<{
  value: components['schemas']['ItemsReviews']
}>()
</script>
